import React from 'react'
import { Container, Image, Spacer, Text } from 'roadie-ui'
import { Container as Framework, Module, Slide, Video, Agree } from 'components/pages/certifications/framework'

import { TRAINING_CERTS } from 'util/constants'

import slide01Image from 'images/training/mail-innovations/mi-icon-color.png'
import slide02Image from 'images/training/mail-innovations/02-image.png'
import slide03Image from 'images/training/mail-innovations/03-image.png'
import slide05Image1 from 'images/training/mail-innovations/05-image-01.png'
import slide05Image2 from 'images/training/mail-innovations/05-image-02.png'
import slide06Image from 'images/training/mail-innovations/06-image.png'
import slide07Image1 from 'images/training/mail-innovations/07-image-01.png'
import slide07Image2 from 'images/training/mail-innovations/07-image-02.png'
import slide08Image1 from 'images/training/mail-innovations/08-image-01.png'
import slide08Image2 from 'images/training/mail-innovations/08-image-02.png'
import slide08Image3 from 'images/training/mail-innovations/08-image-03.png'
import slide08Image4 from 'images/training/mail-innovations/08-image-04.png'
import slide08Image5 from 'images/training/mail-innovations/08-image-05.png'
import bannerPass from 'images/training/mail-innovations/banner-pass.png'
import videoThumb1 from 'images/training/roadie-xd/02-video-thumbnail.png'
import { LocalizedRichText, useLocalization, LocalizedText } from 'localization'

//TODO: Combine with other VimeoVideo components
const VimeoVideo: React.FC<{
  id: string
  thumbnail: string
}> = ({ id, thumbnail }) => {
  const { t } = useLocalization()

  return (
    <Video
      src={`https://player.vimeo.com/video/${id}?autoplay=0&muted=0&autopause=0&controls=1&playsinline=true&loop=0`}
      autoplayWhenVisible={false}
      showVideoInBackground={true}
      height="496"
      thumbnail={<img src={thumbnail} alt={t('dweb_common_video_thumbnail')} />}
    />
  )
}

const MailInnovationsPage: React.FC = () => {
  return (
    <MailInnovationsModule>
      <Module certification={TRAINING_CERTS.MAIL_INNOVATIONS.CERT}>
        <Slide>
          <Spacer $height="1.6rem" />
          <Container.Base $textAlign="center">
            <Image width="25%" src={slide01Image} />
          </Container.Base>
          <Spacer $height="3.2rem" />
          <Text.H4>
            <LocalizedText translationKey="dweb_certifications_mail_innovations_how_complete_mail_innovations_gig" />
          </Text.H4>
          <Spacer $height="1.6rem" />
          <Text.Body2>
            <LocalizedText translationKey="dweb_certifications_mail_innovations_intro_high_volume_gigs" />
            <br />
            <br />
            <LocalizedText translationKey="dweb_certifications_mail_innovations_training_intro" />
          </Text.Body2>
        </Slide>
        <Slide>
          <Spacer $height="1.6rem" />
          <Text.H5 $fontWeight="600">
            <LocalizedText translationKey="dweb_certifications_mail_innovations_what_mail_innovations_gigs" />
          </Text.H5>
          <Spacer $height="3.2rem" />
          <Container.Base $textAlign="center">
            <Image width="100%" src={slide02Image} />
          </Container.Base>
          <Spacer $height="3.2rem" />
          <Text.Body2>
            <LocalizedText translationKey="dweb_certifications_mail_innovations_intro_sender_description" />
            <br />
            <br />
            <LocalizedText translationKey="dweb_certifications_mail_innovations_guidelines_importance" />
          </Text.Body2>
        </Slide>
        <Slide>
          <Spacer $height="1.6rem" />
          <Text.H5 $fontWeight="600">
            <LocalizedText translationKey="dweb_certifications_mail_innovations_getting_started_mail_innovations_gigs" />
          </Text.H5>
          <Spacer $height="3.2rem" />
          <Container.Base $textAlign="center">
            <Image width="75%" src={slide03Image} />
          </Container.Base>
          <Spacer $height="3.2rem" />
          <Text.Body2>
            <LocalizedRichText
              translationKey="dweb_certifications_mail_innovations_get_started"
              params={{
                br: <br />,
                strongText1: (
                  <strong>
                    <u>
                      <LocalizedText translationKey="dweb_mail_innovations_do_not_show_up" />
                    </u>
                  </strong>
                ),
              }}
            />
          </Text.Body2>
        </Slide>
        <Slide>
          <Spacer $height="1.6rem" />
          <Text.H5 $fontWeight="600">
            <LocalizedText translationKey="dweb_certifications_mail_innovations_roadie_xd_cross_dock_safety" />
          </Text.H5>
          <Spacer $height="0.8rem" />
          <Text.Body2>
            <LocalizedText translationKey="dweb_certifications_mail_innovations_most_mail_innovations_gigs_will_picked_up_from" />
          </Text.Body2>
          <Spacer $height="3.2rem" />
          <VimeoVideo id="963535457" thumbnail={videoThumb1} />
        </Slide>
        <Slide>
          <Spacer $height="1.6rem" />
          <Text.H5 $fontWeight="600">
            <LocalizedText translationKey="dweb_certifications_mail_innovations_picking_up_mail_innovations_gigs" />
          </Text.H5>
          <Spacer $height="1.6rem" />
          <ol>
            <li>
              <Text.Body2>
                <LocalizedText translationKey="dweb_certifications_mail_innovations_when_arrive_at_pickup_location_open_roadie_app" />
              </Text.Body2>
            </li>
            <Container.Base $textAlign="center">
              <Spacer $height="1.6rem" />
              <Image width="80%" src={slide05Image1} />
              <Spacer $height="1.6rem" />
            </Container.Base>
            <li>
              <Text.Body2>
                <LocalizedText translationKey="dweb_certifications_mail_innovations_pickup_bag_handoff" />
              </Text.Body2>
            </li>
            <Spacer $height="1.6rem" />
            <li>
              <Text.Body2>
                <LocalizedText translationKey="dweb_certifications_mail_innovations_bag_id_may_last_4_digits_barcode_printed" />
              </Text.Body2>
            </li>
            <Container.Base $textAlign="center">
              <Spacer $height="1.6rem" />
              <Image width="100%" src={slide05Image2} />
              <Spacer $height="1.6rem" />
            </Container.Base>
            <li>
              <Text.Body2>
                <LocalizedRichText
                  translationKey="dweb_certifications_mail_innovations_sorting_packages_rule"
                  params={{
                    strongText1: (
                      <strong>
                        <u>
                          <LocalizedText translationKey="dweb_mail_innovations_do_not_open_sort" />
                        </u>
                      </strong>
                    ),
                  }}
                />
              </Text.Body2>
            </li>
            <Spacer $height="1.6rem" />
          </ol>
        </Slide>
        <Slide>
          <Spacer $height="1.6rem" />
          <Text.H5 $fontWeight="600">
            <LocalizedText translationKey="dweb_certifications_mail_innovations_delivery_process" />
          </Text.H5>
          <Spacer $height="1.6rem" />
          <Text.Body2>
            <LocalizedText translationKey="dweb_certifications_mail_innovations_first_stop_intro" />
          </Text.Body2>
          <ol>
            <li>
              <Text.Body2>
                <LocalizedText translationKey="dweb_certifications_mail_innovations_open_bag_instructions" />
              </Text.Body2>
            </li>
            <Spacer $height="1.6rem" />
            <li>
              <Text.Body2>
                <LocalizedText translationKey="dweb_certifications_mail_innovations_tracking_number_match" />
              </Text.Body2>
            </li>
            <Container.Base $textAlign="center">
              <Spacer $height="1.6rem" />
              <Image width="100%" src={slide06Image} />
              <Spacer $height="1.6rem" />
            </Container.Base>
            <li>
              <Text.Body2>
                <LocalizedText translationKey="dweb_certifications_mail_innovations_confirm_package_address" />
              </Text.Body2>
            </li>
          </ol>
        </Slide>
        <Slide>
          <Spacer $height="1.6rem" />
          <Text.H5 $fontWeight="600">
            <LocalizedText translationKey="dweb_certifications_mail_innovations_delivery_process" />
          </Text.H5>
          <ol start={4}>
            <li>
              <Text.Body2>
                <LocalizedRichText
                  translationKey="dweb_certifications_mail_innovations_scan_delivery_barcode"
                  params={{
                    strongText1: (
                      <strong>
                        <LocalizedText translationKey="dweb_certifications_mail_innovations_center" />
                      </strong>
                    ),
                  }}
                />
              </Text.Body2>
            </li>
            <Container.Base $textAlign="center">
              <Spacer $height="1.6rem" />
              <Image width="100%" src={slide07Image1} />
              <Spacer $height="1.6rem" />
            </Container.Base>
            <li>
              <Text.Body2>
                <LocalizedText translationKey="dweb_certifications_mail_innovations_delivery_photo_tip" />
              </Text.Body2>
            </li>
            <Container.Base $textAlign="center">
              <Spacer $height="1.6rem" />
              <Text.H5 $fontWeight="700" $textAlign="center">
                <LocalizedRichText
                  translationKey="dweb_mail_innovations_photo_dos_donts_heading"
                  params={{
                    br: <br />,
                    dosText: (
                      <Text.H5 $fontWeight="700" $color="primary-dark">
                        <LocalizedText translationKey="dweb_certifications_mail_innovations_dos" />
                      </Text.H5>
                    ),
                    dontsText: (
                      <Text.H5 $fontWeight="700" $color="error-base">
                        <LocalizedText translationKey="dweb_certifications_mail_innovations_donts" />
                      </Text.H5>
                    ),
                  }}
                />
              </Text.H5>
              <Spacer $height="1.6rem" />
              <Image width="100%" src={slide07Image2} />
              <Spacer $height="1.6rem" />
            </Container.Base>
            <li>
              <Text.Body2>
                <LocalizedRichText
                  translationKey="dweb_certifications_mail_innovations_next_delivery_after_completion"
                  params={{
                    strongText1: (
                      <strong>
                        <LocalizedText translationKey="dweb_certifications_mail_innovations_keep_plastic_bag_s_return_them_pickup_location" />
                      </strong>
                    ),
                  }}
                />
              </Text.Body2>
            </li>
            <Spacer $height="1.6rem" />
          </ol>
        </Slide>
        <Slide>
          <Spacer $height="1.6rem" />
          <Text.H5 $fontWeight="600">
            <LocalizedText translationKey="dweb_certifications_mail_innovations_delivery_process" />
          </Text.H5>
          <Spacer $height="1.6rem" />
          <Container.Grid $gridTemplateColumns="8rem 1fr" $gridGap="1.6rem" $padding={'1.6rem 0'}>
            <Container.Base $textAlign="center">
              <Image width="100%" src={slide08Image1} />
            </Container.Base>
            <Text.Body2>
              <LocalizedRichText
                translationKey="dweb_certifications_mail_innovations_strong_text1_tap_get_help_then_select_i"
                params={{
                  strongText1: (
                    <strong>
                      <LocalizedText translationKey="dweb_certifications_mail_innovations_package_mismatch" />
                    </strong>
                  ),
                }}
              />
            </Text.Body2>
          </Container.Grid>
          <Container.Grid $gridTemplateColumns="8rem 1fr" $gridGap="1.6rem" $padding={'1.6rem 0'}>
            <Container.Base $textAlign="center">
              <Image width="100%" src={slide08Image2} />
            </Container.Base>
            <Text.Body2>
              <LocalizedRichText
                translationKey="dweb_certifications_mail_innovations_call_box_contact_tip"
                params={{
                  strongText1: (
                    <strong>
                      <LocalizedText translationKey="dweb_certifications_mail_innovations_if_delivery_location_has_gate" />
                    </strong>
                  ),
                }}
              />
            </Text.Body2>
          </Container.Grid>
          <Container.Grid $gridTemplateColumns="8rem 1fr" $gridGap="1.6rem" $padding={'1.6rem 0'}>
            <Container.Base $textAlign="center">
              <Image width="100%" src={slide08Image3} />
            </Container.Base>
            <Text.Body2>
              <LocalizedRichText
                translationKey="dweb_certifications_mail_innovations_suite_number_check_tip"
                params={{
                  strongText1: (
                    <strong>
                      <LocalizedText translationKey="dweb_certifications_mail_innovations_if_delivery_location_business_complex" />
                    </strong>
                  ),
                }}
              />
            </Text.Body2>
          </Container.Grid>
          <Container.Grid $gridTemplateColumns="8rem 1fr" $gridGap="1.6rem" $padding={'1.6rem 0'}>
            <Container.Base $textAlign="center">
              <Image width="100%" src={slide08Image4} />
            </Container.Base>
            <Text.Body2>
              <LocalizedRichText
                translationKey="dweb_certifications_mail_innovations_extra_package_photo_tip"
                params={{
                  strongText1: (
                    <strong>
                      <LocalizedText translationKey="dweb_certifications_mail_innovations_if_delivery_address_location_roadie_app_do_not" />
                    </strong>
                  ),
                }}
              />
            </Text.Body2>
          </Container.Grid>
          <Container.Grid $gridTemplateColumns="8rem 1fr" $gridGap="1.6rem" $padding={'1.6rem 0'}>
            <Container.Base $textAlign="center">
              <Image width="100%" src={slide08Image5} />
            </Container.Base>
            <Text.Body2>
              <LocalizedRichText
                translationKey="dweb_certifications_mail_innovations_barcode_manual_entry_tip"
                params={{
                  strongText1: (
                    <strong>
                      <LocalizedText translationKey="dweb_certifications_mail_innovations_if_have_issues_scanning_barcode_at_delivery" />
                    </strong>
                  ),
                }}
              />
            </Text.Body2>
          </Container.Grid>
        </Slide>
        <Slide>
          <Spacer $height="1.6rem" />
          <Text.H5 $fontWeight="600">
            <LocalizedText translationKey="dweb_certifications_mail_innovations_return_process" />
          </Text.H5>
          <Spacer $height="3.2rem" />
          <Text.Body2>
            <LocalizedRichText
              translationKey="dweb_certifications_mail_innovations_return_issue_instructions"
              params={{
                strongText1: (
                  <strong>
                    <LocalizedText translationKey="dweb_certifications_mail_innovations_tap_get_help_app_follow_instructions_set_up" />
                  </strong>
                ),
                br: <br />,
                strongText2: (
                  <strong>
                    <LocalizedText translationKey="dweb_certifications_mail_innovations_do_not_leave_items_outside_return_location" />
                  </strong>
                ),
              }}
            />
          </Text.Body2>
        </Slide>
        <Slide>
          <Spacer $height="1.6rem" />
          <Text.H5 $fontWeight="600">
            <LocalizedText translationKey="dweb_certifications_mail_innovations_please_confirm" />
          </Text.H5>
          <Spacer $height="1.6rem" />
          <Text.Body2>
            <LocalizedText translationKey="dweb_certifications_mail_innovations_completion_acknowledgement" />
          </Text.Body2>
          <Spacer $height="1.6rem" />
          <Agree
            toRichKey="dweb_certifications_mail_innovations_agree_no_early_arrival"
            params={{
              strongText1: (
                <strong>
                  <LocalizedText translationKey="dweb_certifications_mail_innovations_no_early_waiting_ack" />
                </strong>
              ),
            }}
          />
          <Agree
            toRichKey="dweb_certifications_mail_innovations_agree_no_passengers_or_animals"
            params={{
              strongText1: (
                <strong>
                  <LocalizedText translationKey="dweb_certifications_mail_innovations_no_passengers_acknowledgement" />
                </strong>
              ),
            }}
          />
          <Agree
            toRichKey="dweb_certifications_mail_innovations_agree_professional_conduct"
            params={{
              strongText1: (
                <strong>
                  <LocalizedText translationKey="dweb_certifications_mail_innovations_treat_all_staff_at_cross_dock_respect_conduct" />
                </strong>
              ),
            }}
          />
          <Agree
            toRichKey="dweb_certifications_mail_innovations_agree_follow_safety_procedures"
            params={{
              strongText1: (
                <strong>
                  <LocalizedText translationKey="dweb_certifications_mail_innovations_safety_attire_acknowledgement" />
                </strong>
              ),
            }}
          />
          <Agree
            toRichKey="dweb_certifications_mail_innovations_agree_bring_license_and_insurance"
            params={{
              strongText1: (
                <strong>
                  <LocalizedText translationKey="dweb_certifications_mail_innovations_bring_license_insurance" />
                </strong>
              ),
            }}
          />
          <Agree
            toRichKey="dweb_certifications_mail_innovations_agree_complete_all_deliveries"
            params={{
              strongText1: (
                <strong>
                  <LocalizedText translationKey="dweb_certifications_mail_innovations_complete_all_deliveries_ack" />
                </strong>
              ),
            }}
          />
          <Agree
            toRichKey="dweb_certifications_mail_innovations_agree_theft_prosecution"
            params={{
              strongText1: (
                <strong>
                  <LocalizedText translationKey="dweb_certifications_mail_innovations_theft_any_kind_amount_will_prosecuted" />
                </strong>
              ),
            }}
          />
          <Agree
            toRichKey="dweb_certifications_mail_innovations_agree_strict_compliance"
            params={{
              strongText1: (
                <strong>
                  <LocalizedText translationKey="dweb_certifications_mail_innovations_terms_acknowledgement" />
                </strong>
              ),
            }}
          />
          <Spacer $height="1.6rem" />
        </Slide>
        <Slide>
          <Image width="100%" src={bannerPass} />
          <Spacer $height="3.2rem" />
          <Text.H5 $fontWeight="600">
            <LocalizedText translationKey="dweb_certifications_mail_innovations_great_job" />
          </Text.H5>
          <Spacer $height="1.6rem" />
          <Text.Body2>
            <LocalizedText translationKey="dweb_certifications_mail_innovations_completion_success" />
          </Text.Body2>
        </Slide>
      </Module>
    </MailInnovationsModule>
  )
}

const MailInnovationsModule: React.FC<React.PropsWithChildren> = (props) => {
  const { t } = useLocalization()

  return (
    <Container.Base $color="neutral-black">
      <Framework title={t('dweb_certifications_mail_innovations_title')} {...props} />
    </Container.Base>
  )
}

export default MailInnovationsPage
